<template>
  <router-view />
  <BaseTable
    :headers="[
      t('global.name'),
      t('marketing.filter_groups.filters_used'),
    ]"
    :rows="
      items.map((item) => ({
        id: item.id,
      cells: [
        item.name,
        item.filters.length,
      ],
      actions: [
        {
          name: 'edit',
          icon: 'edit',
          label: t('global.actions.edit'),
        },
        item.filters.length ? {
          name: 'email',
          icon: 'email',
          label: t('global.actions.email'),
        } : '',
        {
          name: 'delete',
          icon: 'delete',
          label: t('global.actions.delete'),
        },
      ]
    }))
    "
    @action="onAction"
    v-test="'filter-groups'"
  ></BaseTable>
</template>

<script
  setup
  lang="ts"
>
import { useMutation } from '@vue/apollo-composable';
import { defineProps } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { formatFilters } from '@/helpers/formatting';
import { flash, modal } from '@/helpers/ui';
import type { CustomerFilterGroup } from '@/types';
import { useMarketingStore } from '../store';
import { DELETE_CUSTOMER_FILTER_GROUP } from './graphql';

const { t } = useI18n();
const router = useRouter();

const props = defineProps<{
  items: CustomerFilterGroup[];
}>();

const deleteFilterGroup = (id: number) => {
  const { mutate } = useMutation(DELETE_CUSTOMER_FILTER_GROUP, {
    variables: {
      input: {
        id,
      },
    },
    update(cache) {
      cache.evict({ id: `CustomerFilterGroup:${id}`, broadcast: false });
      cache.gc();
    },
  });

  mutate().then(() => {
    flash(t('global.flash.filter_group_deleted'));
  });
};

const onAction = ({ id, option }) => {
  const item = props.items.find((item) => item.id === id);
  if (option === 'edit') {
    router.push({
      name: 'edit-filter-group',
      params: { filterGroupId: id },
    });
  }

  if (option === 'email') {
    const { setAllFilters } = useMarketingStore();
    setAllFilters(formatFilters(item?.filters || []));
    router.push({ name: 'newsletter-template' });
  }

  if (option === 'delete') {
    modal('confirmation', {
      type: 'delete',
      item: t('global.items.filter_group'),
    }).then(() => {
      deleteFilterGroup(Number.parseInt(id));
    });
  }
};
</script>
